export const READING = 'reading';
export const ESPANOL = 'spanish';
export const MATH = 'math';

export const IDEL = 'idel';
export const IDEL2 = 'idel2';
export const CLPL = 'clpl';
export const R3DSPANISH = 'r3dspanish';
export const OLS_SPANISH = 'olsspanish';
export const OLS = 'ols';
export const DIBELS8 = 'dibels8';
export const R3D = 'r3d';
export const BURST = 'burst';
export const MATH_APP = 'math';
export const MATHCBM = 'mathcbm';

export const APPLICATIONS_GROUPS_NAMES = [READING, ESPANOL, MATH];
export const APP_GROUPS_DISPLAY_NAMES = {
    [READING]: 'Reading',
    [ESPANOL]: 'Espa\xF1ol', // Español,
    [MATH]: 'Math',
};
export const AVAILABLE_APP_GROUPS = [READING, ESPANOL];

export const APPLICATION_DISPLAY_NAME = {
    [DIBELS8]: 'DIBELS',
    [R3D]: 'TRC',
    [BURST]: 'mCLASS Intervention',
    [OLS]: 'OLS',
    [IDEL]: 'IDEL',
    [IDEL2]: 'Spanish R&D',
    [R3DSPANISH]: 'TRC',
    [OLS_SPANISH]: 'OLS SPANISH',
    [MATHCBM]: 'MATH',
};

export const APPLICATION_LIST_NAME = {
    DIBELS8,
    R3D,
    BURST,
    OLS,
    IDEL,
    IDEL2,
    R3DSPANISH,
    OLS_SPANISH,
    MATHCBM,
};

// order of application rows in BM summary
export const APPLICATIONS_GROUPS = {
    [READING]: [DIBELS8, OLS, R3D, BURST],
    [ESPANOL]: [IDEL, IDEL2, OLS_SPANISH, R3DSPANISH],
    [MATH]: [MATHCBM],
};

export const APP_GROUP_BY_APPLICATION_ID = {
    [DIBELS8]: READING,
    [R3D]: READING,
    [BURST]: READING,
    [IDEL]: ESPANOL,
    [IDEL2]: ESPANOL,
    [R3DSPANISH]: ESPANOL,
    [MATHCBM]: MATH,
    [OLS]: READING,
    [OLS_SPANISH]: ESPANOL,
};

export const EDITIONS = {
    MCLASS_TX_EDITION: 'mCLASS Texas',
};

export const BENCHMARK_BOOKLIST_SID = {
    NEW_READING_3D_SPANISH_BOOK_SET: 20,
    ATLAS_SPANISH: 28,
};

export const IDEL2_EDITIONS = {
    LECTURA: 'Lectura',
    INVENTARIO: 'Inventario',
};
